import React from 'react';

const TermsOfService: React.FC = () => (
  <div className="max-w-2xl mx-auto py-12 px-4">
    <h1 className="text-2xl font-bold mb-4">Terms of Service</h1>
    <p className="mb-4">Effective date: July 15, 2025</p>
    <p className="mb-4">
      By using Backlog Explorer ("the app"), you agree to the following terms and conditions. Please read them carefully.
    </p>
    <h2 className="text-xl font-semibold mt-6 mb-2">1. Use of the App</h2>
    <p className="mb-4">
      You may use the app for personal, non-commercial purposes only. Do not misuse the app or attempt unauthorized access.
    </p>
    <h2 className="text-xl font-semibold mt-6 mb-2">2. User Content</h2>
    <p className="mb-4">
      You are responsible for any content you add to your library or submit as feedback. Do not upload illegal, offensive, or infringing material.
    </p>
    <h2 className="text-xl font-semibold mt-6 mb-2">3. Account</h2>
    <p className="mb-4">
      You are responsible for maintaining your account security. You may delete your account at any time.
    </p>
    <h2 className="text-xl font-semibold mt-6 mb-2">4. Disclaimer</h2>
    <p className="mb-4">
      The app is provided "as is" without warranties of any kind. We are not responsible for any damages or data loss.
    </p>
    <h2 className="text-xl font-semibold mt-6 mb-2">5. Changes</h2>
    <p className="mb-4">
      We may update these terms from time to time. Continued use of the app means you accept the revised terms.
    </p>
    <h2 className="text-xl font-semibold mt-6 mb-2">6. Contact</h2>
    <p>
      For questions about these terms, contact us at <a href="mailto:joanaponder@gmail.com" className="underline">joanaponder@gmail.com</a>.
    </p>
  </div>
);

export default TermsOfService;
